export default {"src":"/_next/static/media/sparkle.a6598d04.svg","height":46,"width":42,"blurWidth":0,"blurHeight":0};